"use strict";

export default {};
